import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { InfoXs } from '@lichtblick/photon/icons/symbols/info-xs';
import { Modal } from '@lichtblick/photon/organisms/modal/modal';
import { useId } from 'react';
import styles from './reason-why-tooltip.module.scss';
export const ReasonWhyTooltip = ({ content })=>{
    const modalId = useId();
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TextCTA, {
                as: "button",
                className: styles['tooltip-link'],
                icon: /*#__PURE__*/ _jsx(InfoXs, {}),
                command: "show-modal",
                commandFor: modalId,
                slim: true,
                type: "button",
                variant: "thin",
                children: "Warum wird diese Information benötigt?"
            }),
            /*#__PURE__*/ _jsx(Modal, {
                title: "Warum wird diese Information benötigt?",
                footerContent: /*#__PURE__*/ _jsx(TextCTA, {
                    as: "button",
                    type: "button",
                    command: "close",
                    commandFor: modalId,
                    children: "Alles klar!"
                }),
                id: modalId,
                children: content
            })
        ]
    });
};

//# sourceMappingURL=reason-why-tooltip.js.map